module.exports = __webpack_public_path__ + "assets/aaaa29295a8c186552f65ca08c570921.mp3";